import { LiveElement, LiveNodeList } from 'live-node-list'
import { bind } from 'decko'

export default class Recharge {
  /**
   * @type {LiveNodeList}
   */
  products = new LiveNodeList('.collection__list-item')

  /**
   * @type {LiveNodeList}
   */
  formToggles = new LiveNodeList('.quick-buy-form__toggle')

  /**
   * @type {LiveNodeList}
   */
  rechargeContainers = new LiveNodeList('.collection__list-item .rc-container')

  /**
   * @type {LiveNodeList}
   */
  dropdowns = new LiveNodeList('.rc_widget__option__plans__dropdown')

  /**
   * @type {LiveNodeList}
   */
  purchaseOptions = new LiveNodeList('.rc_widget__option__input')

  /**
   * @type {LiveNodeList}
   */
  subscriptionOptions = new LiveNodeList('.rc_widget__option__input--subsave')

  /**
   * @type {LiveNodeList}
   */
  subscriptionTooltips = new LiveNodeList('.rc_popup')

  /**
   * @type {LiveElement}
   */
  requestAccountContainer = new LiveElement('.page__customers__request-invite')

  constructor() {
    this.registerListeners()

    this.waitForRecharge()
  }

  registerListeners() {
    this.dropdowns.on('update', (newItems, oldItems) => {
      newItems.forEach(this.rewriteOptions)
    })

    this.dropdowns.forEach(this.rewriteOptions)

    this.purchaseOptions.addEventListener('change', this.handleOptionChange)
    this.purchaseOptions.addEventListener('click', this.handleOptionChange)
    this.subscriptionTooltips.on('update', (newItems, oldItems) => {
      this.handleOptionChange()
    })
    this.handleOptionChange()

    this.products.on('update', (newItems, oldItems) => {
      if ('ReChargeWidget' in window) {
        this.createRechargeWidgets(newItems)
      }
    })

    if ('ReChargeWidget' in window) {
      this.createRechargeWidgets()
    }

    this.formToggles.addEventListener('click', event => {
      this.formToggles.forEach(item =>
        item.setAttribute('aria-expanded', 'false')
      )
      const button = event.currentTarget || event.target
      button.setAttribute(
        'aria-expanded',
        button.getAttribute('aria-expanded') === 'false'
      )
    })

    this.products.addDelegatedEventListener(document, 'click', event => {
      this.formToggles.forEach(button => {
        button.setAttribute('aria-expanded', 'false')
      })
    })

    this.products.addEventListener('click', event => {
      event.stopPropagation()
    })

    this.rechargeContainers.on('update', (newItems, oldItems) => {
      newItems.forEach(this.insertFormToggle)
    })

    /**
     * Recharge don't set a body class on their account request page,
     * so we imitate the login page here to inherit styles
     */
    this.requestAccountContainer.on('update', (newItem, oldItem) => {
      if (newItem && document.body.classList.contains('template-')) {
        document.body.classList.remove('template-')
        document.body.classList.add('template-login')
      }
    })
    if (
      this.requestAccountContainer.item &&
      document.body.classList.contains('template-')
    ) {
      document.body.classList.remove('template-')
      document.body.classList.add('template-login')
    }
  }

  @bind
  async waitForRecharge() {
    if ('ReChargeWidget' in window) {
      this.createRechargeWidgets()
      return true
    }

    setTimeout(this.waitForRecharge, 1000)
    return false
  }

  @bind
  async createRechargeWidgets(items = this.products.items) {
    this.products.pause()
    await window.ReChargeWidget.api.fetchWidgetSettings()
    items.forEach(item => {
      const id = parseInt(item.dataset.productId)
      if (window.ReChargeWidget.getWidget(id)) {
        return
      }

      const form = item.querySelector(`#product_form_${id}`)
      if (!form || form.dataset.isSubscriptionProduct !== 'true') {
        return
      }

      const widget = window.ReChargeWidget.createWidget({
        productId: id,
        injectionParent: `#product_form_${id}`,
      })
    })
    this.products.resume()
  }

  @bind
  rewriteOptions(dropdown) {
    Array.prototype.forEach.call(dropdown.children, item => {
      item.innerHTML = item.innerHTML.replace('Delivery every ', '')
    })
  }

  @bind
  handleOptionChange(event) {
    this.subscriptionTooltips.forEach(item => {
      const subscriptionOption = item.parentNode.querySelector(
        this.subscriptionOptions.selector
      )

      item?.setAttribute(
        'aria-hidden',
        (!subscriptionOption?.checked).toString()
      )
    })
  }

  @bind
  insertFormToggle(item) {
    if (!item.classList.contains('collection__list-item')) {
      item = item.closest('.collection__list-item')
    }

    const button = `
      <button class="button button--primary quick-buy-form__toggle" id="toggle_recharge_form_${item.dataset.productId}" type="button" aria-expanded="false" aria-controls="product_form_${item.dataset.productId}">
        <div class="smoke__blobs">
          <div class="smoke__blob"></div>
          <div class="smoke__blob"></div>
          <div class="smoke__blob"></div>
          <div class="smoke__blob"></div>
        </div>

        <span class="button__text">
          ${window.theme.strings.buyNow}
        </span>
      </button>
    `
    const dummy = document.createElement('div')
    dummy.innerHTML = button

    const form = item.querySelector('.quick-buy-form')
    form.insertBefore(dummy.firstElementChild, form.firstElementChild)
  }
}
